import { mapGetters } from "vuex";
import trans from "@/data/forms/mixins/trans.js";
import transOptions from "@/support/transitions/mixins/transOptions.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import moment from "moment";

export default {
  data() {
    return {
      act: true,
      maxHistSize: 50 // maximum size of history
    };
  },
  computed: {
    ...mapGetters(["getUser", "getTransitions", "getDetail"]),
    trans() {
      return this.getTransitions;
    }
  },
  // eslint-disable-next-line
  mixins: [
    listFunctions,
    transOptions,
    docRevsModFunctions,
    trans
  ],
  methods: {
    generateInitalTransition(tag) {
      let model = null;
      if (tag === "B1") {
        model = "AR";
      }
      if (tag === "B3") {
        model = "E";
      }
      if (tag === "B4") {
        model = "CB";
      }
      if (tag === "B6") {
        model = "CP";
      }
      if (tag === "E2") {
        model = "AE";
      }
      if (tag === "G1") {
        model = "Y";
      }
      if (tag === "O1") {
        model = "O";
      }
      if (tag === "Q1") {
        model = "BO";
      }
      if (tag === "M2") {
        model = "CS";
      }
      if (tag === "M5") {
        model = "AMP";
      }
      if (tag === "S6") {
        model = "D";
      }
      if (tag === "W1") {
        model = "B";
      }

      // RETURN Temp
      let temp = this.generateTransition(model);
      return temp;
    },
    generateTransition(model) {
      // initial
      let temp = this.formTransitions;
      temp.model = model;
      temp.flow = [];
      temp.hist = [];
      // create flow
      let ucom = "Approval workflow created.";
      let tempFlow = this.generateFlow(true, ucom, "Created", "add");
      // generate history
      temp.flow.push(tempFlow);
      temp.hist.push(tempFlow);
      // console.log("GENERATE INITIAL TRANS");
      // console.log(temp);
      // return temp.
      return temp;
    },
    defineFlow(model) {
      let temp = null;
      if (model == "A") {
        temp = this.transitionsFlowModelA;
      } else if (model == "AE") {
        temp = this.transitionsFlowModelAE;
      } else if (model == "AP") {
        temp = this.transitionsFlowModelAP;
      } else if (model == "AMP") {
        temp = this.transitionsFlowModelAMP;
      } else if (model == "AR") {
        temp = this.transitionsFlowModelAR;
      } else if (model == "B") {
        temp = this.transitionsFlowModelB;
      } else if (model == "B") {
        temp = this.transitionsFlowModelB;
      } else if (model == "BO") {
        temp = this.transitionsFlowModelBO;
      } else if (model == "CB") {
        temp = this.transitionsFlowModelCB;
      } else if (model == "CP") {
        temp = this.transitionsFlowModelCP;
      } else if (model == "CS") {
        temp = this.transitionsFlowModelCS;
      } else if (model == "D") {
        temp = this.transitionsFlowModelD;
      } else if (model == "E") {
        temp = this.transitionsFlowModelE;
      } else if (model == "O") {
        temp = this.transitionsFlowModelO;
      } else if (model == "W") {
        temp = this.transitionsFlowModelW;
      } else if (model == "Y") {
        temp = this.transitionsFlowModelY;
      } else {
        temp = null;
      }
      // HELP CONSOLE LOG
      return temp;
    },
    defineFlowItem(model, index) {
      let temp = null;
      temp = this.defineFlow(model);
      temp = temp[index];
      return temp;
    },
    generateFlow(result, ucom, title, icon) {
      let temp = this.formTransitionsFlow;
      temp.agree = result;
      temp.uname = this.getUser.basic.title;
      temp.ucom = ucom;
      temp.title = title; // title of step
      temp.icon = icon; // title of step
      temp.udid = this.getUser.basic.did;
      temp.uemail = this.getUser.basic.email;
      temp.date = moment().format();
      return temp;
    },
    defineMaxProcessStep(model) {
      let num = 0;
      num = this.defineFlow(model).length;
      return num;
    },
    progressTranistion(result, step, ucom) {
      // declare common variables
      let temp = this.trans; // main transition
      // update temp
      temp.level = step + 1;
      temp.stat.revert = false;
      temp.stat.lock = false;
      temp.stat.progress = true; // completed
      temp.stat.defer = false;
      temp.ntrans = temp.ntrans + 1; // number of transitions

      // create new flow
      // HELP
      // console.log("PROGRESS TRANSITIONS HELP");
      // console.log("MODEL   " + temp.model);
      // console.log("LEVEL   " + temp.level);
      // console.log("COMMENT " + ucom);

      // RESTRCTION on LEVEL for ACCESS USER
      if (this.getDetail.basic === "G1") {
        if (temp.level > 2) {
          temp.level = 2;
        }
      }

      let title = this.defineFlowItem(temp.model, temp.level - 1).title;
      let icon = this.defineFlowItem(temp.model, temp.level - 1).icon;

      // console.log("PROGRESS TRANSITIONS GET INFO");
      // eslint-disable-next-line
      // console.log("TITLE " + this.defineFlowItem(temp.model, temp.level - 1).title);
      // eslint-disable-next-line
      // console.log("ICON " + this.defineFlowItem(temp.model, temp.level - 1).icon);

      // SECTION for ACCESS APPROVAL
      let tag = this.getDetail.basic.tag;
      if (tag === "G1" && result === true) {
        // .new is used to estimate if new user or reapproval
        if (temp.stat.active === false && temp.stat.new === false) {
          temp.stat.active = true;
          temp.stat.new = true;
        } else {
          temp.stat.active = true;
          temp.stat.new = false;
        }
        title = "Active";
        icon = "person";
      }
      if (tag === "G1" && result === false) {
        temp.stat.active = false;
        title = "Rejected";
        icon = "no_accounts";
      }
      let tempFlow = this.generateFlow(result, ucom, title, icon);
      let obj = Object.assign({}, tempFlow);
      temp.flow.push(obj);
      // eslint-disable-next-line
      temp.hist = this.appendItemLimited(obj, this.trans.hist, this.maxHistSize);

      // UPDATE Store
      // eslint-disable-next-line
      this.$store.dispatch("changeTransitionStatusPrevious", temp.flow[temp.flow.length - 2].title);
      // eslint-disable-next-line
      this.$store.dispatch("changeTransitionStatusCurrent", temp.flow[temp.flow.length - 1].title);
      this.$store.dispatch("changeTransitions", temp);
      this.$store.dispatch("changeDataSavePendingIndication", true);
      this.saveDocumentRevMod(4.21, 1); // approval progress
      // this.changeUnsavedIndicator();
      console.log("");
      console.log("APPROVAL PROCESS - ACCESS");
      console.log(temp);
    },
    updateTransitionHistory(ucom, title, icon) {
      let temp = this.trans; // main transition
      temp.ntrans = temp.ntrans + 1; // number of transitions
      let tempFlow = this.generateFlow(true, ucom, title, icon);
      let obj = Object.assign({}, tempFlow);
      // eslint-disable-next-line
      temp.hist = this.appendItemLimited(obj, this.trans.hist, this.maxHistSize);
      this.$store.dispatch("changeTransitions", temp);
      this.$store.dispatch("changeDataSavePendingIndication", true);
      this.saveDocumentRevMod(4.21, 1); // approval progress
      // this.changeUnsavedIndicator();
    },
    cancelTranistion(step, ucom) {
      this.cancelBtnPressed = true;
      // declare common variables
      let temp = this.trans; // main transition
      // update temp
      temp.level = step;
      temp.stat.revert = false;
      temp.ntrans = temp.ntrans + 1; // number of transitions
      // create new flow
      let title = "Cancelled";
      let icon = "block";
      let tempFlow = this.generateFlow(true, ucom, title, icon);
      let obj = Object.assign({}, tempFlow);
      temp.flow.push(obj);
      // eslint-disable-next-line
      temp.hist = this.appendItemLimited(obj, this.trans.hist, this.maxHistSize);
      // UPDATE Store
      console.log("CANCEL");
      // eslint-disable-next-line
      this.$store.dispatch("changeTransitionStatusPrevious", "");
      // eslint-disable-next-line
      this.$store.dispatch("changeTransitionStatusCurrent", temp.flow[temp.flow.length - 1].title);
      this.$store.dispatch("changeTransitions", temp);
      this.$store.dispatch("changeDataSavePendingIndication", true);
      this.saveDocumentRevMod(4.22, 2); // approval reverted.
      // this.changeUnsavedIndicator();
    },
    revertTranistion(step, ucom) {
      // declare common variables
      let temp = this.trans; // main transition
      // update temp
      temp.level = step - 1;
      temp.stat.revert = true;
      temp.ntrans = temp.ntrans + 1; // number of transitions
      // create new flow
      let title = this.defineFlowItem(temp.model, temp.level - 1).title;
      let icon = this.defineFlowItem(temp.model, temp.level - 1).icon;
      let tempFlow = this.generateFlow(true, ucom, title, icon);
      let obj = Object.assign({}, tempFlow);
      temp.flow.pop();
      // eslint-disable-next-line
      temp.hist = this.appendItemLimited(obj, this.trans.hist, this.maxHistSize);
      // UPDATE Store
      console.log("REVERT");
      // eslint-disable-next-line
      this.$store.dispatch("changeTransitionStatusPrevious", "");
      // eslint-disable-next-line
      this.$store.dispatch("changeTransitionStatusCurrent", temp.flow[temp.flow.length - 1].title);
      this.$store.dispatch("changeTransitions", temp);
      this.$store.dispatch("changeDataSavePendingIndication", true);
      this.saveDocumentRevMod(4.22, 2); // approval reverted.
      // this.changeUnsavedIndicator();
    },
    holdTransition(result, ucom) {
      // declare common variables
      // put hold to current level
      let temp = this.trans; // main transition
      temp.stat.hold = result;
      temp.ntrans = temp.ntrans + 1; // repeated

      // Overwrite with detail comm details as well as icons
      // create new flow
      let title = "";
      let icon = "";
      if (result === true) {
        title = "Hold";
        icon = "pending";
        this.saveDocumentRevMod(4.23, 3); // hold
      } else {
        title = "Review";
        icon = "manage_search";
        this.saveDocumentRevMod(4.24, 4); // unhold deciison
      }
      let tempFlow = this.generateFlow(result, ucom, title, icon);
      let obj = Object.assign({}, tempFlow);
      // eslint-disable-next-line
      temp.hist = this.appendItemLimited(obj, this.trans.hist, this.maxHistSize);
      // UPDATE Store
      // eslint-disable-next-line
      this.$store.dispatch("changeTransitions", temp);
      this.$store.dispatch("changeDataSavePendingIndication", true);
    },
    lockTransition(result, ucom) {
      // declare common variables
      // put hold to current level
      let temp = this.trans; // main transition
      temp.stat.lock = result;
      temp.stat.progress = false;
      temp.ntrans = temp.ntrans + 1; // repeated

      // Overwrite with detail comm details as well as icons
      // create new flow
      let title = "";
      let icon = "";
      if (result === true) {
        title = "Lock";
        icon = "lock";
        this.saveDocumentRevMod(4.23, 3); // hold
      } else {
        title = "Active";
        icon = "person";
        this.saveDocumentRevMod(4.24, 4); // unhold deciison
      }
      let tempFlow = this.generateFlow(result, ucom, title, icon);
      let obj = Object.assign({}, tempFlow);
      // eslint-disable-next-line
      temp.hist = this.appendItemLimited(obj, this.trans.hist, this.maxHistSize);
      // UPDATE flow
      // eslint-disable-next-line
      temp.flow[temp.flow.length - 1].icon = icon;
      temp.flow[temp.flow.length - 1].title = title;
      // UPDATE Store
      // eslint-disable-next-line
      this.$store.dispatch("changeTransitions", temp);
      this.$store.dispatch("changeDataSavePendingIndication", true);
    },
    cancelTransition(result, com) {
      // declare common variables
      // put hold to current level
      let temp = this.trans; // main transition
      temp.stat.cancel = result;
      temp.ntrans = temp.ntrans + 1; // repeated

      // Overwrite with detail comm details as well as icons
      // create new flow
      let tempFlow = this.generateFlow(com);
      temp.level = temp.flow[temp.flow.length - 1];

      // update last histry only
      let obj = Object.assign({}, tempFlow);
      temp.hist.push(obj);
      // update last flow
      // let obj = Object.assign({}, tempFlow);
      // UPDATE Store
      console.log(tempFlow);
      // eslint-disable-next-line
      this.$store.dispatch("changeTransitions", temp);
      this.$store.dispatch("changeDataSavePendingIndication", true);
      if (result === true) {
        this.saveDocumentRevMod(4.25); // cancelled
      } else {
        this.saveDocumentRevMod(4.26); // unc1ancelled
      }
    },
    calcTransionsProgressBar() {
      let per = 0;
      let completed = this.getTransitions.flow.length;
      let model = this.getTransitions.model;
      let total = this.defineTransSize(model);
      // eslint-disable-next-line
      per = completed / total;
      per = per * 100;
      per = per.toFixed(1);
      return per;
    }
  }
};
